import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_ChangeLogTable = _resolveComponent("ChangeLogTable")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      type: "card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "基本信息",
          name: "info"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Form)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "余额变动",
          name: "balance",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ChangeLogTable, {
              "log-type": "balance",
              "user-id": _ctx.userId,
              "show-user-column": false
            }, null, 8, ["user-id"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "点数变动",
          name: "point",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ChangeLogTable, {
              "log-type": "point",
              "user-id": _ctx.userId,
              "show-user-column": false
            }, null, 8, ["user-id"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "积分变动",
          name: "membership_point",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ChangeLogTable, {
              "log-type": "membership_point",
              "user-id": _ctx.userId,
              "show-user-column": false
            }, null, 8, ["user-id"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}